var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 23,
    viewBox: "0 0 138 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Discover"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9946 11.4987C41.9946 17.8815 47.0075 22.8296 53.4553 22.8296C55.2794 22.8296 56.8387 22.47 58.7646 21.5649V16.5801C57.072 18.2727 55.5723 18.9567 53.6517 18.9567C49.386 18.9567 46.3585 15.8644 46.3585 11.4671C46.3585 7.2996 49.4842 4.01083 53.4553 4.01083C55.4759 4.01083 57.0054 4.72998 58.7646 6.45241V1.46928C56.9071 0.527375 55.3776 0.13623 53.5552 0.13623C47.1391 0.13623 41.9946 5.18602 41.9946 11.4987Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1249 6.22614C31.1249 7.39782 31.8721 8.01874 34.4137 8.95889C39.2319 10.7217 40.6597 12.2827 40.6597 15.7329C40.6597 19.9355 37.5709 22.8612 33.1701 22.8612C29.9479 22.8612 27.6046 21.593 25.6524 18.7287L28.3886 16.0942C29.3639 17.9797 30.9916 18.9901 33.0104 18.9901C34.9013 18.9901 36.2992 17.6868 36.2992 15.9276C36.2992 15.0155 35.8747 14.2314 35.0293 13.6807C34.6031 13.4193 33.7594 13.0282 32.1019 12.4441C28.1238 11.0128 26.7592 9.48158 26.7592 6.48924C26.7592 2.93563 29.6901 0.267781 33.5314 0.267781C35.9116 0.267781 38.0901 1.08164 39.9125 2.67603L37.6954 5.57716C36.5921 4.34058 35.5502 3.81789 34.2803 3.81789C32.4544 3.81789 31.1249 4.85802 31.1249 6.22614Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21796 0.627387H0V22.3403H6.18464C9.47165 22.3403 11.8483 21.565 13.9321 19.8338C16.4088 17.7833 17.8734 14.6928 17.8734 11.4987C17.8734 5.09134 13.0849 0.627387 6.21796 0.627387ZM11.1643 16.9397C9.83298 18.1394 8.10528 18.6638 5.36902 18.6638H4.23243V4.30729H5.36902C8.10528 4.30729 9.76457 4.79491 11.1643 6.06306C12.6306 7.36628 13.5094 9.3869 13.5094 11.4672C13.5094 13.5509 12.6306 15.6364 11.1643 16.9397Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.058 0.627387H19.8221V22.3403H24.058V0.627387Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5552 0.627387L92.3469 15.2102L98.2123 0.627387H102.803L93.4221 22.898H91.1436L81.9298 0.627387H86.5552Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.718 22.3403H116.729V18.6638H108.95V12.8037H116.442V9.12555H108.95V4.30729H116.729V0.627387H104.718V22.3403Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.813 0.627387C130.698 0.627387 133.501 2.97249 133.501 7.03653C133.501 10.3621 131.742 12.5441 128.551 13.1931L135.387 22.3403H130.179L124.317 13.6176H123.763V22.3403H119.534V0.627387H125.813ZM123.763 10.6235H125.003C127.708 10.6235 129.141 9.44829 129.141 7.26631C129.141 5.15273 127.708 4.04595 125.068 4.04595H123.763V10.6235Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.876 1.76576C136.876 1.38338 136.611 1.17466 136.15 1.17466H135.536V3.09003H135.992V2.34809L136.527 3.09003H137.086L136.457 2.30073C136.725 2.22706 136.876 2.03061 136.876 1.76576ZM136.069 2.0271H135.992V1.52546H136.074C136.301 1.52546 136.418 1.6079 136.418 1.77277C136.418 1.94116 136.299 2.0271 136.069 2.0271Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.573 2.12876C134.573 1.20089 135.313 0.45894 136.241 0.45894C137.146 0.45894 137.89 1.21492 137.89 2.12876C137.89 3.04786 137.146 3.79857 136.241 3.79857C135.32 3.79857 134.573 3.05487 134.573 2.12876ZM134.904 2.13051C134.904 2.89175 135.503 3.50039 136.234 3.50039C136.964 3.50039 137.556 2.88473 137.556 2.13051C137.556 1.3833 136.964 0.758875 136.234 0.758875C135.497 0.758875 134.904 1.36927 134.904 2.13051Z",
    fill: "#251F1F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Element_2",
    filter: "url(#filter0_i_461_4511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.6021 23C65.2561 23 60.1099 17.8538 60.1099 11.5078V11.4922C60.1099 8.33478 61.3884 5.46194 63.4563 3.39403C63.4563 3.37803 63.4723 3.37803 63.4723 3.36246C63.4879 3.36246 63.4879 3.34646 63.5039 3.34646C65.5718 1.27855 68.4451 0 71.6021 0H71.6181C77.9641 0 83.1103 5.14619 83.1103 11.4922V11.5078C83.1103 14.6652 81.8313 17.5225 79.7634 19.6064C79.7634 19.622 79.7479 19.622 79.7479 19.638C79.7319 19.638 79.7319 19.6535 79.7163 19.6535C77.6324 21.7215 74.7751 23 71.6181 23H71.6021Z",
    fill: "url(#paint0_linear_461_4511)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_461_4511",
    x: 60.1099,
    y: 0,
    width: 23.9774,
    height: 24.4654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.976924,
    dy: 1.46539
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.976924
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_461_4511"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_461_4511",
    x1: 65.5824,
    y1: -2.46942e-7,
    x2: 84.4812,
    y2: 15.9919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#F04D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7911D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/Discover.69a71baba6db6a57a060a0f2395f51a3.svg";
export { ForwardRef as ReactComponent };